/* eslint-disable */
export default {
  contactDetails: 'Detalhes de contacto',
  loadingContact: 'A carregar contacto...',
  contactNotFound: 'Contacto não encontrado.',
} as const;

// @key: @#@"contactDetails"@#@ @source: @#@"Contact Details"@#@
// @key: @#@"loadingContact"@#@ @source: @#@"Loading contact..."@#@
// @key: @#@"contactNotFound"@#@ @source: @#@"Contact not found."@#@
